import { Badge } from '@/components/ui';
import type { MovementStatus } from '@/api/services/movements.service';

const TONES: Record<MovementStatus, 'success' | 'warning' | 'danger' | 'neutral' | 'info'> = {
  draft: 'neutral',
  submitted: 'info',
  approved: 'info',
  scheduled: 'warning',
  applied: 'success',
  rejected: 'danger',
  cancelled: 'neutral',
  failed: 'danger',
  blocked: 'danger',
};

export function MovementStatusBadge({ status }: { status: MovementStatus }): React.ReactElement {
  return (
    <Badge variant={TONES[status] ?? 'neutral'} className="capitalize">
      {status.replaceAll('_', ' ')}
    </Badge>
  );
}
